import React, { useEffect, useRef, useState } from 'react';
import { Header, TitleSize } from 'azure-devops-ui/Header';
import { IHeaderCommandBarItem } from 'azure-devops-ui/HeaderCommandBar';
import { Image } from 'azure-devops-ui/Image';
import { IAuthContext } from '../../common/hooks/outsetaAuthProvider';
import Profile from './Profile';
import { ProfileService } from '../../common/services/profile.service';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { TeachingService } from '../services/teach.service';
import { Location } from 'azure-devops-ui/Utilities/Position';
import { useTeachingService } from './Teach';

interface IMainHeaderProps {
  authContext: IAuthContext;
  profileService: ProfileService;
}

interface IPortalConfig {
  portalTop: number;
  portalLeft: number;
  display: boolean;
}

export default function MainHeader(props: IMainHeaderProps) {
  const { user, logout, openLogin, openSignup, openProfile, isLoading } = props.authContext;
  const [portalConfig, setPortalConfig] = useState({} as IPortalConfig);
  const teachingService = useTeachingService();
  const navigate = useNavigate();
  const headerRef = useRef<HTMLDivElement>(null);
  const teachingBubblePosition = 0;

  console.debug(user);

  const loggedInButtons: IHeaderCommandBarItem[] = [
    {
      iconProps: {
        iconName: 'Edit',
      },
      id: 'useDefaults',
      important: true,
      isPrimary: true,
      text: 'Use Sample Data',
      className: 'teach',
      subMenuProps: {
        id: 'defaultOptions',
        items: [
          {
            id: 'none',
            text: 'None',
            onActivate: () => {
              navigate('/');
              teachingService.markAsDone(teachingBubblePosition);
            },
          },
          {
            id: 'crappy',
            text: 'Bad',
            onActivate: () => {
              navigate('bad');
            },
          },
          {
            id: 'moderate',
            text: 'Better',
            onActivate: () => {
              navigate('better');
            },
          },
          {
            id: 'advanced',
            text: 'Better Still',
            onActivate: () => {
              navigate('better-still');
            },
          },
          {
            id: 'advanced-french',
            text: 'Better Still, but in French',
            onActivate: () => {
              navigate('better-still-french');
            },
          },
        ],
      },
    },
    {
      iconProps: {
        iconName: 'UserFollowed',
      },
      id: 'loggedin',
      important: true,
      text: user && user.FullName,
      onActivate: (menuItem, event) => {
        console.log(menuItem);
        console.log(event);
        togglePortal(event.currentTarget);
      },
    },
    {
      iconProps: {
        iconName: 'UserRemove',
      },
      id: 'signout',
      important: true,
      onActivate: () => {
        logout();
      },
      text: 'Sign Out',
    },
  ];

  if (!isMobile)
    loggedInButtons.splice(1, 0, {
      iconProps: {
        iconName: 'Download',
      },
      id: 'install',
      important: true,
      text: 'Install Extension',
      tooltipProps: {
        text: 'Install the Azure DevOps or Jira extension for Ogg',
      },
      subMenuProps: {
        id: 'installOptions',
        items: [
          {
            id: 'ado',
            text: 'Azure DevOps',
            onActivate: (menuItem, event) => {
              window.open(
                'https://marketplace.visualstudio.com/items?itemName=Intriq.ogg-4-ado',
                '_blank'
              );
            },
          },
          {
            id: 'jira',
            text: 'Jira',
            onActivate: (menuItem, event) => {
              window.open(
                'https://marketplace.atlassian.com/apps/1234545/ogg-enhance-the-quality-of-your-stories-using-ai',
                '_blank'
              );
            },
          },
        ],
      },
    });

  function togglePortal(element: HTMLElement) {
    setPortalConfig({
      display: !portalConfig.display,
      portalLeft: element?.offsetLeft,
      portalTop: element?.offsetTop + 32,
    });
  }

  useEffect(() => {
    if (!headerRef) return;
    const teachElement = headerRef.current.getElementsByClassName('teach').item(0);
    if (!teachElement) return;

    teachingService.registerBubble(
      {
        anchorElement: teachElement as HTMLDivElement,
        anchorOrigin: { horizontal: Location.start, vertical: Location.end },
        title: 'Try using some sample data',
        text: 'Use some predefined work item details and project settings to get you going.',
        onDismiss: () => {},
      },
      teachingBubblePosition
    );

    return () => teachingService.unregisterBubble(teachingBubblePosition);
  });

  return (
    <div className='ogg-header' ref={headerRef}>
      <Header
        title='Ogg'
        commandBarItems={!!user ? loggedInButtons : []}
        titleSize={TitleSize.Medium}
        titleIconProps={{
          render: () => (
            <Image
              alt='Logo'
              src={require('../../common/img/logo.png')}
              width={30}
              containImage={true}
            />
          ),
        }}
        titleAriaLevel={3}
      />
      {portalConfig.display && (
        <Profile
          profileService={props.profileService}
          portalLeft={portalConfig.portalLeft}
          portalTop={portalConfig.portalTop}
          close={() => togglePortal(null)}
        />
      )}
    </div>
  );
}
